"use strict";exports.__esModule = true;exports.default = void 0;var _default = {
  setExpandedState(isExpanded) {
    if (isExpanded !== this.state.expanded) {
      this.state.expanded = isExpanded;
      if (isExpanded) {
        this.emit('expanded');
      } else {
        this.emit('collapsed');
      }
    }
  },

  handleExpand() {
    this.setExpandedState(!this.state.expanded);
  },

  handleScroll() {
    this.setExpandedState(true);
  },

  handleTouchStart(event) {
    var touches = event.changedTouches;
    this.touches = [];
    for (var i = 0; i < touches.length; i++) {
      var { identifier, pageY } = touches[i];
      this.touches.push({
        identifier,
        pageY });

    }
  },

  handleTouchMove(event) {var _this = this;
    if (this.touches.length) {var _loop = function _loop(
      i) {
        var current = event.changedTouches[i];
        var compare = _this.touches.findIndex(
        (item) => item.identifier === current.identifier);

        var diff = current.pageY - _this.touches[compare].pageY;

        if (diff > 30) {
          // Drag down, collpase
          if (_this.state.expanded) {
            _this.setExpandedState(false);
          } else {
            _this.getComponent('dialog').state.open = false;
          }
          _this.handleTouchEnd(event);
        } else if (diff < -30) {
          _this.setExpandedState(true);
          _this.handleTouchEnd(event);
        }};for (var i = 0; i < event.changedTouches.length; i++) {_loop(i);
      }
    }
  },

  handleTouchEnd(event) {var _this2 = this;var _loop2 = function _loop2(
    i) {
      var current = event.changedTouches[i];
      var idx = _this2.touches.findIndex((item) => item.identifier === current.identifier);
      if (idx > -1) {
        _this2.touches.splice(idx, 1);
      }};for (var i = 0; i < event.changedTouches.length; i++) {_loop2(i);
    }
  },

  onMount() {
    this.touches = [];
  },

  onInput(input) {
    this.state = { expanded: input.expanded || false };
  } };exports.default = _default;module.exports = exports.default;